import React from "react";
import { LoadingOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import "./HotelBookingProcessingOverlay.scss";

const COPY = {
  hold: {
    title: "Processing Your Hold Request...",
    subtitle:
      "Please do not refresh, close, or navigate away from this page until the process is complete.",
  },
  voucher: {
    title: "Generating Your Hotel Voucher...",
    subtitle:
      "Please do not refresh, close, or navigate away from this page until the process is complete.",
  },
};

const HotelBookingProcessingOverlay = ({
  flow = "hold",
  inline = false,
  className = "",
}) => {
  const variant = flow === "voucher" ? "voucher" : "hold";
  const { title, subtitle } = COPY[variant] ?? COPY.hold;
  const antIcon = (
    <LoadingOutlined style={{ fontSize: 42, color: "#d5436a" }} spin />
  );

  return (
    <div
      className={`hotel-booking-processing ${inline ? "hotel-booking-processing--inline" : ""} ${className}`.trim()}
      role="status"
      aria-live="polite"
      aria-busy="true"
    >
      <div className="hotel-booking-processing__card">
        <Spin indicator={antIcon} />
        <h2 className="hotel-booking-processing__title">{title}</h2>
        <p className="hotel-booking-processing__subtitle">{subtitle}</p>
        <div className="hotel-booking-processing__dots" aria-hidden="true">
          <span />
          <span />
          <span />
        </div>
      </div>
    </div>
  );
};

export default HotelBookingProcessingOverlay;
